// Buy box PDP: the Shopify Subscriptions app widget is hidden, so pick its purchase option for the shopper.
// Variants with a selling plan (e.g. "Subscribe & Save") get the first plan; all others stay one-time purchases.
(() => {
  const syncPurchaseOption = (container) => {
    const variantInput = container.querySelector('.product-variant-id');
    const widget = container.querySelector('[id*="subscriptions_app_block"]');
    if (!variantInput || !widget) return;

    const variantId = variantInput.value;
    const planRadio = widget.querySelector(`input[data-radio-type="selling_plan"][name$="_${variantId}"]`);
    const oneTimeRadio = widget.querySelector(`input[data-radio-type="one_time_purchase"][name$="_${variantId}"]`);
    const target = planRadio || oneTimeRadio;

    // Click so the app's own handler fills its hidden selling_plan input
    if (target && !target.checked) target.click();
  };

  const init = () => {
    document.querySelectorAll('.product--buy-box').forEach((container) => {
      syncPurchaseOption(container);

      // The app re-renders the widget for each variant, so re-apply whenever it changes
      const widget = container.querySelector('[id*="subscriptions_app_block"]');
      if (widget) {
        new MutationObserver(() => syncPurchaseOption(container)).observe(widget, { childList: true, subtree: true });
      }
    });
  };

  document.addEventListener('variant:change', () => {
    document.querySelectorAll('.product--buy-box').forEach(syncPurchaseOption);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
